import React from "react";
import { Tooltip } from "@blueprintjs/core";
import ErrorIcon from "icons/info_triangle.svg";
import * as styles from "./styles.module.scss";
const BiasedIcon = ({ left }) => {
    return (React.createElement("div", { className: styles.icon, style: { left: `${left}px` } },
        React.createElement(Tooltip, { minimal: true, content: "At least one calculated value is biased.", placement: "bottom", popoverClassName: styles.tooltip, rootBoundary: "viewport", openOnTargetFocus: false },
            React.createElement(ErrorIcon, { className: styles["error-icon"] }))));
};
export default BiasedIcon;
